
<div class="amplify-album">
  <div class="amplify-album-container">
    <amplify-s3-image-core
      class="amplify-image-container"
      *ngFor="let item of list"
      path="{{item.path}}"
      [options]="_options"
      (selected)="onImageSelected($event)"
    ></amplify-s3-image-core>
  </div>
</div>
